import { View } from 'react-native'
import { Image } from 'expo-image'

import { marketPresentation } from '@/config/marketPresentation'
import { Logo, LogoWithLabel, LogoWithLabelDark } from '@/components/icon'

type BrandLogoProps = {
  className?: string
  variant?: 'icon' | 'wordmark'
  dark?: boolean
}

export default function BrandLogo({ className, variant = 'icon', dark = false }: BrandLogoProps) {
  const logoUrl = marketPresentation.branding.logoUrl

  if (logoUrl) {
    return (
      <Image
        source={logoUrl}
        contentFit={'contain'}
        accessibilityLabel={marketPresentation.branding.displayName}
        className={className}
        style={variant === 'wordmark' ? { width: 64, height: 38 } : undefined}
      />
    )
  }

  if (variant === 'wordmark') {
    return <View className={className}>{dark ? <LogoWithLabelDark /> : <LogoWithLabel />}</View>
  }

  return <Logo className={className} />
}
